/**
 * Labstep
 *
 * @module components/ResourceItem/Action/Create/Template/Metadata
 * @desc Action to create a ResourceItem template from metadata
 */

import { MetadataActionCreateModal } from 'labstep-web/components/Metadata/Action/Create/Modal';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { EntityCanCreateContainer } from 'labstep-web/containers/Entity/Create/Can';
import { Metadata } from 'labstep-web/models/metadata';
import { Resource } from 'labstep-web/models/resource.model';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import type React from 'react';
import type { IResourceItemActionCreateTemplateMetadataProps } from './types';
import { getOnSubmit } from './utils';

export const ResourceItemActionCreateTemplateMetadata: React.FC<
  IResourceItemActionCreateTemplateMetadataProps
> = ({ resource, actionComponentProps, options, ...rest }) => (
  <EntityCanCreateContainer
    entityName={ResourceItem.entityName}
    parentName={Resource.entityName}
    parentId={resource.id}
  >
    {({
      create: createResourceItemTemplate,
      status: resourceItemStatus,
    }): React.ReactElement => (
      <EntityCreateContainer entityName={Metadata.entityName}>
        {({
          create: createMetadata,
          status: metadataStatus,
        }): React.ReactElement => (
          <MetadataActionCreateModal
            entity={resource.resource_item_template}
            entityName={ResourceItem.entityName}
            actionComponentProps={actionComponentProps}
            isTemplate
            onSubmit={getOnSubmit({
              createResourceItemTemplate,
              createMetadata,
              resource,
              options,
            })}
            disableAddAnother
            options={options}
            status={
              resourceItemStatus?.isFetching
                ? resourceItemStatus
                : metadataStatus
            }
            {...rest}
          />
        )}
      </EntityCreateContainer>
    )}
  </EntityCanCreateContainer>
);
